import { render } from "./CardiologiePage.vue?vue&type=template&id=5a3cc927"
import script from "./CardiologiePage.vue?vue&type=script&lang=js"
export * from "./CardiologiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__